/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Project_File_DescInputs */



/**
* | output |
* | --- |
* | "Save as .ccprj file" |
*
* @param {File_Export_Project_File_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_project_file_desc = /** @type {((inputs?: File_Export_Project_File_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Project_File_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer en .ccprj")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als .ccprj-Datei speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva come file .ccprj")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните как файл .ccprj")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar como archivo .ccprj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("另存为 .ccprj 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ (".ccprjファイルとして保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इसे .ccprj फ़ाइल के रूप में सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar como arquivo .ccprj")
	return /** @type {LocalizedString} */ ("Save as .ccprj file")
});